import React, { useState } from "react"
import TestimonialCarousel from "../../components/testimonialCarousel"
import CarouselSterring from "../../components/carouselSterring"
import Box from "@material-ui/core/Box"

import Container from "@material-ui/core/Container"
import Grid from "@material-ui/core/Grid"

import hearthWrapper from "../../assets/testimonial-hearth.png"

import Fade from "react-reveal/Fade"

import { FormattedMessage } from "gatsby-plugin-react-intl"

const MomTestimonialsBanner = ({ cms }) => {
  const [swiper, setSwiper] = useState(null)

  const onSwiperCreated = swiper => {
    setSwiper(swiper)
  }

  const onSwipeNext = () => {
    if (swiper) {
      swiper.slideNext()
    }
  }

  const onSwipePrev = () => {
    if (swiper) {
      swiper.slidePrev()
    }
  }

  return (
    <>
      <Box className="mom-testimonials-banner" component="section">
        <img
          className="hearth-wrapper"
          src={hearthWrapper}
          alt="Ipad with carebits app view"
        ></img>
        <Container maxWidth="xl" disableGutters={true}>
          <Grid container>
            <Grid item xs={12} lg={4} className="banner-left">
              <h1>
                <FormattedMessage
                  id="momTestimonialsBanner_Title"
                  defaultMessage="Historie Mam"
                />
              </h1>
              <p>
                <FormattedMessage
                  id="momTestimonialsBanner_Subtitle"
                  defaultMessage="Przeczytaj opinie naszych Klientek o Carebits"
                />
              </p>
              <CarouselSterring
                swipeNext={onSwipeNext}
                swipePrev={onSwipePrev}
              ></CarouselSterring>
            </Grid>
            <Grid item xs={12} lg={8} className="banner-right">
              <Fade right fraction={0.5}>
                <TestimonialCarousel
                  data={cms.edges}
                  swipperCreated={onSwiperCreated}
                ></TestimonialCarousel>
              </Fade>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  )
}

export default MomTestimonialsBanner
